<template>
    <div class="btn-titulo bg-secondary"  :key="auto.id" v-on:click="segundoPaso">
        <img
                :src="uri+auto.dt5"
                :alt="auto.dt1 + 'logo'"
                class="img-fluid img-logo"/>
        <v-lazy-image
                :src="auto.dt4 ? uri+auto.dt4 : defecto"
                :src-placeholder="cargada"
                :alt="auto.dt1"
                class="img-fluid imagen-btn"/>
    </div>
</template>

<script>
    import VLazyImage from "v-lazy-image";
    import constantes from "../constantes";
    export default {
        name: "boton-auto",
        data:()=>({
            uri:process.env.VUE_APP_URL_API,
            defecto:require("../../src/assets/images/default.jpg"),
            cargada:require("../../src/assets/images/default_loading.jpg"),
        }),
        components:{
            VLazyImage
        },
        props:{
            auto:Object
        },
        methods:{
            generarUrl:function(){
                let autoDat = this.auto;
                autoDat.url= constantes.funciones.urlParse(this.auto.dt1);
                return autoDat;
            },
            segundoPaso:function(){
                this.$emit('elegido', this.generarUrl());
            }
        }
    }
</script>

<style scoped>
    .btn-titulo{
        border: none;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        cursor: pointer;
    }
    .btn-titulo:hover{
        filter: none;
        -webkit-filter: grayscale(20%);
        -moz-filter:    grayscale(20%);
        -ms-filter:     grayscale(20%);
        -o-filter:      grayscale(20%);
        cursor: pointer;
        transition: all 300ms ease;
    }
    .btn-titulo:hover >.img-logo{
        animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
    }
    .img-logo{
        height: 38px;
        position: absolute;
        margin-top: 10px;
        display: block;
        margin-left: 8px;
        margin-right: 6px;
        z-index: 100;
    }
    @keyframes shake {
        10%, 90% {
            transform: translate3d(-1px, 0, 0);
        }
        20%, 80% {
            transform: translate3d(2px, 0, 0);
        }
        30%, 50%, 70% {
            transform: translate3d(-4px, 0, 0);
        }
        40%, 60% {
            transform: translate3d(4px, 0, 0);
        }
    }

</style>
